import { Injectable } from '@angular/core';

import DomainEventProvider from '../../../../../core/domain/events/domain_event_provider';
import { AppointmentEvent } from './appointment.event';

@Injectable({ providedIn: 'root' })
export class AppointmentEventProvider extends DomainEventProvider<AppointmentEvent> {}
